import { render, staticRenderFns } from "./CardIcon.vue?vue&type=template&id=52705af8&scoped=true"
import script from "./CardIcon.vue?vue&type=script&lang=ts"
export * from "./CardIcon.vue?vue&type=script&lang=ts"
import style0 from "./CardIcon.vue?vue&type=style&index=0&id=52705af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52705af8",
  null
  
)

export default component.exports